import mainLogo from '../../assets/logos/main-logo.png';

const Header = () => (
  <header id="app-header" className="grid h-20 place-content-center">
    <img src={mainLogo} alt="main-logo" className="h-8" />
  </header>
);

export default Header;
